import axios from "axios";
import { useHttpErrorHandler } from "../../hooks/useHttpErrorHandler";

// TODO: This is not needed, remove it
export default function StoriesRaw() {
  const { httpErrorHandler, errorStatus } = useHttpErrorHandler();

  const handleOpenJson = async () => {
    let API_URL = `${process.env.REACT_APP_FEATURED_API}`;
    let axiosT = axios.create({
      baseURL: `${API_URL}`,
      headers: {
        'Authorization': `JWT ${localStorage.getItem('token')}`
      }
    });
    axiosT
      .get("/")
      .then((response) => {
        if (response.status !== 200) {
          const errorDetails = {
            status: response.status,
          };
          console.log("error error: ", response.status);
          throw errorDetails;
        }
        const formattedJson = JSON.stringify(response.data.files);
        const blob = new Blob([formattedJson], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
      })
      .catch((err) => {
        httpErrorHandler(err);
      })
  };

  if (errorStatus) return <div>API error, status {errorStatus}</div>;

  return (
    <div>
      <button onClick={handleOpenJson}>View JSON Data</button>
    </div>
  );
}
